import {
  AppAction,
  ProcessAction,
  SettingAction,
  ProvinceAction,
  DistrictAction,
  SubDistrictAction,
  PermAction,
  AuthAction,
} from './actions';
import { AppReducer, AuthReducer, MasterState, PermReducer } from './reducers';
import { ProcessReducer } from './reducers/process.reducer';
import { AppState, AuthState, PermState, SettingState } from './states';
import { ProcessState } from './states/process.state';
import { SettingReducer } from './reducers/setting.reducer';
import { MasterReducer } from './reducers/master.reducer';
import { MasterEffects } from './effects';

export { AppState, ProcessState, SettingState, MasterState };

interface NgRxState {
  App: AppState;
  Auth: AuthState;
  Process: ProcessState;
  settingObject: SettingState;
  Master: MasterState;
  Perm: PermState;
}

const NgRxReducer = {
  App: AppReducer,
  Auth: AuthReducer,
  Process: ProcessReducer,
  settingObject: SettingReducer,
  Master: MasterReducer,
  Perm: PermReducer,
};

const Reducer = {
  AppReducer,
  AuthReducer,
  ProcessReducer,
  SettingReducer,
  MasterReducer,
  PermReducer,
};

const Action = {
  AppAction,
  AuthAction,
  ProcessAction,
  SettingAction,
  ProvinceAction,
  DistrictAction,
  SubDistrictAction,
  PermAction,
};
const NgRxEffects = [MasterEffects];
export { NgRxState, NgRxReducer, NgRxEffects, Reducer, Action };
